const actionTypeIdentifier = '3D74F5FC-BE8A-4599-A14F-56B8A8AD3CB6';

export const getInventoryASPU = `GET-ASPU-EXTERNAL-INVENTORY-${actionTypeIdentifier}`;
export const setInventoryASPUError = `SET-ASPU-EXTERNAL-INVENTORY-ERROR-${actionTypeIdentifier}`;
export const setInventoryASPUColSearchStr = `SET-ASPU-EXTERNAL-INVENTORY-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortInventoryASPUItems = `SORT-ASPU-EXTERNAL-INVENTORY-${actionTypeIdentifier}`;
export const setInventoryASPUPageSize = `SET-INVENTORY-ASPU-PAGESIZE-${actionTypeIdentifier}`;
export const setInventoryASPUFilter = `SET-INVENTORY-ASPU-FILTER-${actionTypeIdentifier}`;
export const applyInventoryASPUFilter = `APPLY-INVENTORY-ASPU-FILTER-${actionTypeIdentifier}`;
export const resetInventoryASPUData = `RESET-INVENTORY-ASPU-DATA-${actionTypeIdentifier}`;